const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  // async fetchList({ commit, rootGetters }, payload) {
  //   try {
  //     const defaultPageable = rootGetters['table/defaultPageable'];
  //     const sortBy = payload.sortBy?.[0] ? `${payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;
  //     const params = {
  //       size: defaultPageable.limit,
  //       page: defaultPageable.currentPage - 1,
  //       search: defaultPageable.search,
  //       sortBy
  //     };

  //     let url = `/api/course`;

  //     const {
  //       data: { data }
  //     } = await window.axios.get(url, { params });
  //     const { content, totalPages, totalElements } = data;

  //     commit('SET_ITEM', content);
  //     commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
  //     commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });
  //   } catch (err) {
  //     throw err;
  //   }
  // },

  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/course?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchListLite({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/course-lite?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchListLiteClass({ commit }, { classroomId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite/course-list?classroomId=${classroomId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/course/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  save({ commit }, payload) {
    return window.axios.post('/api/course/', payload);
  },

  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    return window.axios.put(`/api/course/${payload.id}`, payload);
  },

  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/course/${payload.courseId}`, payload);
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetailLite({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/course-lite/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  saveLite({ commit }, payload) {
    return window.axios.post('/api/course-lite/', payload);
  },

  // eslint-disable-next-line no-unused-vars
  updateLite({ commit }, payload) {
    return window.axios.put(`/api/course-lite/${payload.id}`, payload);
  },

  // eslint-disable-next-line no-unused-vars
  destroyLite({ commit }, payload) {
    return window.axios.delete(`/api/course-lite/${payload.courseId}`, payload);
  }
};

export default { namespaced, state, getters, mutations, actions };
